import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { debounceTime, switchMap } from 'rxjs/operators';
import { RegistrierungService } from '../../services/registrierung.service';
import { RegistrierungComponent } from '../registrierung.component';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-zusammenfassung',
  imports: [NgOptimizedImage, TranslatePipe],
  templateUrl: './zusammenfassung.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './zusammenfassung.component.scss',
})
export class ZusammenfassungComponent {
  private readonly registrierungService = inject(RegistrierungService);
  protected stepper = inject(RegistrierungComponent);

  // Signal inputs
  formGroupZusammenfassung = input<FormGroup>({} as FormGroup);

  constructor() {
    // Setup auto-save effect on form value changes
    effect(() => {
      const fg = this.formGroupZusammenfassung();
      if (fg?.valueChanges) {
        fg.valueChanges
          .pipe(
            debounceTime(200),
            switchMap(() => {
              return this.registrierungService.saveRegistrierungsdatenToLocalStorage();
            })
          )
          .subscribe((result) => {
            if (result === false) {
              console.log('formular failure: autosave not executed');
            }
          });
      }
    });
  }
}
